// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import {
  IEditSlot,
  ILockerDetails,
  ISlotEquipmentsEdit,
} from "models/interfaces";

export const getAllLockers = createAsyncThunk(
  "locker/getAllLockers",
  async () => {
    try {
      const response = await REST.get("/locker/locker/get-all-lockers");
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const createLocker = createAsyncThunk(
  "locker/createLocker",
  async (data: ILockerDetails | any, { rejectWithValue }) => {
    try {
      const response = await REST.post("/locker/locker/create-locker", data);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data.details[0]);
    }
  }
);

export const getLocker = createAsyncThunk(
  "locker/getLocker",
  async (lockerId: number | string) => {
    try {
      const response = await REST.get(
        `/locker/locker/get-locker?lockerId=${lockerId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getLockerSlots = createAsyncThunk(
  "slot/getLockerSlots",
  async (lockerId: number | string) => {
    try {
      const response = await REST.get(
        `/locker/locker/get-locker-slots?lockerId=${lockerId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const editLocker = createAsyncThunk(
  "locker/createLocker",
  async (data: ILockerDetails, { rejectWithValue }) => {
    try {
      const response = await REST.put("/locker/locker/edit-locker", data);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data.details[0]);
    }
  }
);

export const deleteLocker = createAsyncThunk(
  "locker/deleteLocker",
  async (id: number) => {
    try {
      const response = await REST.delete(
        `/locker/locker/delete-locker?lockerId=${id}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const getSlot = createAsyncThunk(
  "slot/getSlot",
  async (slotId: number | string) => {
    try {
      const response = await REST.get(`/locker/slot/get-slot?slotId=${slotId}`);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getSlotEquipments = createAsyncThunk(
  "slot/getSlotEquipments",
  async (slotId: number | string) => {
    try {
      const response = await REST.get(
        `/locker/slot/get-slot-equipments?slotId=${slotId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const editSlotEquipments = createAsyncThunk(
  "slot/editSlotEquipments",
  async (data: ISlotEquipmentsEdit) => {
    try {
      const response = await REST.post(
        "/locker/slot/edit-slot-equipments",
        data
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const editSlot = createAsyncThunk(
  "slot/editSlot",
  async (data: IEditSlot, { rejectWithValue }) => {
    try {
      const response = await REST.put("/locker/slot/edit-slot", data);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data.details[0]);
    }
  }
);

export const openSlotDoor = createAsyncThunk(
  "slot/openSlotDoor",
  async (data: { slotId: number; lockerId: number },) => {
    try {
      const response = await REST.post(
        `/locker/slot/open-slot-door?slotPcbNumber=${data.slotId}&lockerId=${data.lockerId}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export const powerUp = createAsyncThunk(
  "locker/power-up",
  async () => {
    try {
      const response = await REST.post(
        `/locker/locker/power-up`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

